import React, { Suspense, lazy } from 'react';
import ChordHelper from '../../resources/model/chordHelper';
import model from '../../resources/model/model';
import { Lyrics } from '../lyrics';
import './song.scss';

const PonyOverlay = lazy(() => import('../ponyOverlay/PonyOverlay'));

// eslint-disable-next-line no-unused-vars
function transpose(lyrics="", howMuch=0){
  if(typeof lyrics !== "string")return ""
  return lyrics.replaceAll(/\[(.*?)\]/g,chord => {
    return chord.replaceAll(/[CDEFGAB][#b]?/g, note => {
      return ChordHelper.getNoteNameById((ChordHelper.getNoteId(note)+howMuch)%12)
    })
  })
}

export function Song({song,columns=1, fontSize=20, trans=0,transposeCapo=false, instrument="", ponyCommand=null, villainControls=null, showPonyOverlay=true}){

    //a capo can be written as a negative "tune down" value - fold everything into
    //0..11 so the label, the chords and the toggle all agree on the same number
    const capoSemis = ((song.capo % 12) + 12) % 12
    let capo = ((capoSemis - (transposeCapo ? trans : 0)) % 12 + 12) % 12
    let displayCapo = !!capo || !!song.capo;
    //the capo is "engaged" when the chords are already transposed up by its
    //amount, so the same shapes play without one - the label then reads "No Capo"
    let capoEngaged = !!song.capo && ((trans % 12) + 12) % 12 === capoSemis
  const isPonySong = Array.isArray(song.genre) && song.genre.includes("ponici");

  //verses do not break, so a song cannot fill more columns than it has verses -
  //an empty column would only squeeze every line and throw off auto fit
  const usedColumns = Math.max(1, Math.min(columns, song.verses?.length || 1));


    const ponyOverlayEnabled = showPonyOverlay && model.settings.ponify && isPonySong;

    return <div id="song" style={{fontSize:fontSize}}>
    {ponyOverlayEnabled && <Suspense fallback={null}>
      <PonyOverlay
        enabled={ponyOverlayEnabled}
        fontSize={fontSize}
        songId={song.id}
        command={ponyCommand}
        villainControls={villainControls}
      />
    </Suspense>}
        <div id="song-head">
          <h1 className="title">{song.title}</h1>
          <h2 className="author">{song.author}</h2>
        </div>
        <div id="lyrics" className={"lyrics"+(!model.settings.lineBreak?" no-line-break":"")} style={{columnCount:usedColumns}}>
            {!!displayCapo&&<div
                className="capo"
                onClick={()=>model.toggleCapo(song)}
                title={capoEngaged?"Play with the capo":"Transpose so no capo is needed"}
            >{capoEngaged?"No Capo":"Capo "+capo}</div>}
            {song.verses?.map((verse,k) => {
                return <div className="verse" key={k}>
                <Lyrics name={verse.name} instrument={instrument}>
                    {verse.lyrics}
                </Lyrics></div>
            })}
        </div>
    </div>
}

